import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Phone, Mail } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="relative py-20 sm:py-24 bg-[#005B63] overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#00A3B1]/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#007A85]/30 rounded-full blur-2xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
              Ready to transform your CRE operations?
            </h2>
            <p className="text-lg text-white/80 mb-8">
              Join leading commercial real estate firms who trust Integrand Analytics for their outsourcing needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="https://calendar.app.google/ugMbuFr7Wm9skbt17" target="_blank" rel="noopener noreferrer">
                <Button
                  size="lg"
                  className="bg-white text-[#005B63] hover:bg-gray-100 text-base px-8 py-6 border-0 shadow-lg transition-all duration-300 group"
                >
                  Schedule a Demo
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </a>
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white/10 text-base px-8 py-6 transition-all duration-300"
              >
                Contact Sales
              </Button>
            </div>
          </div>

          {/* Right Content - Contact Cards */}
          <div className="space-y-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-white/70 text-sm">Call us directly</p>
                  <a href="tel:+16473896552" className="text-white font-semibold text-lg hover:text-[#00A3B1] transition-colors">
                    +1 647 389 6552
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-white/70 text-sm">Email us at</p>
                  <a href="mailto:contact@integrand.in" className="text-white font-semibold text-lg hover:text-[#00A3B1] transition-colors">
                    contact@integrand.in
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
